import React from "react";
import { Helmet } from "react-helmet";
import { Box, Container, Typography } from "@mui/material";
import { Link } from 'react-router-dom';

const NotFound = () => {
  const getRedirectPath = () => {
    const group = localStorage.getItem("group");

    if (group === "trainer" || group === "trainee") {
      return "/app/runninglabs";
    } else if (group === "admin" || group === "ops_users") {
      return "/app/dashboard";
    } else {
      // Default redirection if group is not recognized
      return "/app/dashboard";
    }
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>LabAsService</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          justifyContent: "center",
        }}
      >
        <Container maxWidth="md">
          <Typography align="center" color="textPrimary" variant="h1">
            404: The page you are looking for isn’t here
          </Typography>
          <Typography align="center" color="textPrimary" variant="subtitle2">
            You either tried some shady route or you came here by mistake.
            Whichever it is, try using the navigation
          </Typography>
          <Box sx={{ textAlign: "center", marginTop: 2 }}>
            <Link to={getRedirectPath()} style={{ textDecoration: 'underline', color: 'inherit' }}>
              <Typography align="center" color="primary" variant="h6">
                Go to Home
              </Typography>
            </Link>
          </Box>
          <Box sx={{ textAlign: "center" }}>
            <img
              alt="Under development"
              src="/static/images/undraw_page_not_found_su7k.svg"
              style={{
                marginTop: 50,
                display: "inline-block",
                maxWidth: "100%",
                width: 560,
              }}
            />
          </Box>
        </Container>
      </Box>
    </React.Fragment>
  );
};

export default NotFound;